import React from 'react'
import CampaignBrandMessage from '../../InteractionStudio/CampaignBrandMessage.jsx'
import { featureFlag } from '../../../global/utilities/feature-flag.js'
import { getFundGoalType } from '../Helpers/FundUtility'
// import CampaignBrandMessage from '../../InteractionStudio/CampaignBrandMessage.jsx'

function BrandMessage({ fund }) {
  const { aumBanners } = fund

  const fundGoalType = getFundGoalType(fund)

  let bannerInfo =
    aumBanners?.filter((banner) => banner.type === fundGoalType)[0] || null
  const MULTI_MANAGED = 'multi-managed'

  return (
    bannerInfo && (
      <section className="u-adel-reset" id="brand-message">
        <div id="is-brand-message-content-zone-2">
          {featureFlag('interactionstudio') ? (
            <CampaignBrandMessage
              content={'Testing Interaction Studio Brand Message'}
            />
          ) : (
            <div
              className={`Grid Grid--alignMiddle js-top-ad-banner ${
                fundGoalType == MULTI_MANAGED
                  ? 'u-bgColorDuff'
                  : 'u-bgColorBrandLightest'
              } u-paddingVert3gu hide`}
              data-collapsible="true"
              data-brand-message={bannerInfo?.type}
            >
              <div
                id="aum-message-container"
                className="u-flex u-flexAlignItemsCenter u-sizeConstrained"
              >
                {fundGoalType == MULTI_MANAGED && (
                  <span className="Icon u-sizeFit u-textSizeMsrp3 u-paddingRight2gu">
                    &#x2139;
                  </span>
                )}
                <div
                  dangerouslySetInnerHTML={{ __html: bannerInfo?.message }}
                />
              </div>
            </div>
          )}
        </div>
      </section>
    )
  )
}

export default BrandMessage
